import { render } from "./TotalAccesoHoras.vue?vue&type=template&id=bb7662ba"
import script from "./TotalAccesoHoras.vue?vue&type=script&lang=js"
export * from "./TotalAccesoHoras.vue?vue&type=script&lang=js"

import "./TotalAccesoHoras.vue?vue&type=style&index=0&id=bb7662ba&lang=css"

import exportComponent from "/Users/alexnovoa/Documents/PersonalDrive/proyectos-vue/exclusiones-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__